// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2n28f","title":"AfterBackImages_title__2M8Bu","images":"AfterBackImages_images__3ezbs"};